<p-colorPicker
    #colorPicker
    format="hex"
    [formControl]="control"
    inputId="{{ 'input-' + name }}"
    class="form-control"
></p-colorPicker>
<input
    autocomplete="off"
    #shadowHexCode
    [ngStyle]="{ 'text-transform': 'uppercase', float: 'left' }"
    id="{{ 'hInput-' + name }}"
    maxlength="7"
    [placeholder]="control.placeholder"
    type="text"
    [(ngModel)]="control.value"
    (ngModelChange)="hexChanges($event)"
/>

<!-- <div>
    <em>HEX Pattern error:</em>
    <pre>{{ control.errors | json }}</pre>
</div> -->
